import { useCallback, useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { LockKeyhole, CircleCheck } from 'lucide-react';
import { toast } from 'sonner';
import API, { apiError } from '../../lib/api';
import { Switch } from '../../components/ui/switch';
import { ErpHeading, ErpStatus } from '../../components/erp/ErpShared';

export default function ModulesPage() {
  const { permissions, refresh } = useOutletContext();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState('');
  const load = useCallback(() => { setError(''); API.get('/erp/flags').then(r => setItems(r.data)).catch(e => setError(apiError(e))).finally(() => setLoading(false)); }, []);
  useEffect(() => { load(); }, [load]);
  const toggle = async flag => {
    const reason = window.prompt(`${flag.enabled ? 'Dezactivezi' : 'Activezi'} ${flag.name}? Introdu motivul:`);
    if (!reason) return;
    setBusy(flag.id);
    try { await API.put(`/erp/flags/${flag.id}`, { enabled: !flag.enabled, revision: flag.revision, reason }); toast.success('Starea modulului a fost salvată'); load(); refresh(); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(''); }
  };
  return <><ErpHeading title="Module operaționale" /><ErpStatus list={{ items, loading, error, reload: load }} />{!loading && !error && items.map(f => <div className="erp-record" key={f.id} data-testid={`module-${f.code}`}>
    <div className={`w-10 h-10 rounded-md flex items-center justify-center shrink-0 ${f.available ? 'bg-emerald-500/10 text-emerald-400' : 'bg-white/5 text-zinc-500'}`}>{f.available ? <CircleCheck className="w-5 h-5" /> : <LockKeyhole className="w-5 h-5" />}</div>
    <div className="flex-1 min-w-0"><p className="font-medium break-words">{f.name}</p><p className="text-xs text-muted-foreground mt-1" data-testid={`module-status-${f.code}`}>{f.available ? f.enabled ? 'Activ' : 'Dezactivat' : `Planificat · Sprint ${f.sprint}`}</p></div>
    <Switch aria-label={f.name} checked={f.enabled && f.available} disabled={!f.available || !permissions.includes('flags.write') || busy === f.id} onCheckedChange={() => toggle(f)} data-testid={`module-toggle-${f.code}`} />
  </div>)}</>;
}